import { Typography } from 'antd'
import React from 'react';
import Legend from '../../../../components/Legend/Legend';
import { Trans, useTranslation } from 'react-i18next';

export default function HelpTab() {
    const { t } = useTranslation('naturalForests');

    return <>
        <Typography.Title level={4}>{t("ohjeitaOtsikko")}</Typography.Title>
        <div>
            <p>
                <Trans i18nKey="naturalForests:ohje1" components={{ span: <span />, i: <i className='esri-icon-layers' style={{ 'fontWeight': 'bold' }} /> }}>
                    <span>Karttatasoja voi valita näkyviin oikean alanurkan <i className="esri-icon-layers" style={{ "fontWeight": "bold" }} />-napin takaa.
                        Karttaa voi olla selkeämpi katsella varsinkin Pohjois-Suomessa, jos piilottaa "Valtion metsät" -tason pois näkyvistä.</span>
                </Trans>
            </p>
            <p>
                <span>{t("ohje2")}
                </span>
            </p>
            <p>
                <Trans i18nKey="naturalForests:ohje3" components={{ span: <span />, i: <i className="esri-icon-tracking" style={{ "fontWeight": "bold" }} /> }}>
                    Kartan voi tarkentaa omaan sijaintiin painamalla oikean alanurkan <span><i className="esri-icon-tracking" style={{ "fontWeight": "bold" }} />-nappulaa.</span>
                </Trans>
            </p>
            <p>
                <span>{t("ohje4")}</span>
            </p>
        </div>

        <Legend />
    </>
}